import type { SoftwareCategory } from '../softwareCategory.types';

export class SoftwareCategoryModel {
  private readonly _dto: SoftwareCategory;
  private readonly _parentCategory: SoftwareCategoryModel | undefined;
  private readonly _subCategories: SoftwareCategoryModel[];

  constructor(dto?: SoftwareCategory) {
    this._dto = dto || {} as SoftwareCategory;
    this._parentCategory = dto?.parentCategory ? new SoftwareCategoryModel(dto.parentCategory) : undefined;
    this._subCategories = dto?.subCategories?.map(sub => new SoftwareCategoryModel(sub)) ?? [];
  }

  get originDTO(): SoftwareCategory {
    return this._dto;
  }

  get id() {
    return this._dto.id || '';
  }

  get code() {
    return this._dto.code || '';
  }

  get name() {
    return this._dto.name || '';
  }

  get description() {
    return this._dto.description || '';
  }

  get iconUrl() {
    return this._dto.iconUrl || '';
  }

  get parentCategory() {
    return this._parentCategory;
  }

  get subCategories() {
    return this._subCategories;
  }
}
